namespace $.$$ {
	export class $exso_sheets_app extends $.$exso_sheets_app {
		override title() {
			return `${super.spread_title(this.spread())} | ${super.title()}`
		}
		get $() {
			return super.$.$mol_ambient({
				$mol_locale: class extends $mol_locale {
					static override lang_default() {
						return 'ru'
					}
				},
			})
		}

		@$mol_mem
		override spread_ids() {
			return super.spread_ids().filter(id => !this.ignored_spreads().includes(id))
		}

		override Menu_title() {
			return this.Menu_link('')
		}

		@$mol_mem_key
		override spread_title(id: string) {
			if (!id) return super.title()
			return super.spread_title(id)
		}

		@$mol_mem
		override date(next?: string) {
			const td = this.default_date()
			if (next !== undefined && !next) next = td
			const load = this.$.$mol_state_arg.value('date', next)
			if (load) return load
			return this.$.$mol_state_arg.value('date', td) || td
		}

		@$mol_mem
		override type(next?: string) {
			const d = super.type()
			return this.$.$mol_state_arg.value('type', next === d ? null : next) || d
		}

		override date_format(): string {
			return this.$.$exso_format.date(this.date_moment())
		}

		@$mol_mem
		override default_date(): string {
			return new Date().toISOString().split('T')[0]
		}
		override pages() {
			if (!this.user()) return [this.Login()]
			return super.pages()
		}

		override id(id: string) {
			return id
		}

		@$mol_mem_key
		override page_title(type: 'month' | 'day' | 'auto') {
			if (type === 'auto') type = this.type() as any
			return super
				.page_title(type)
				.replaceAll(
					'{}',
					type === 'day' ? this.date_format() : this.$.$exso_format.month(this.date_moment().native),
				)
		}

		override shifts(type: 'month' | 'day' | 'auto') {
			return this.filter(['shifts', type])
		}
		@$mol_mem
		now() {
			return new Date(this.date())
		}
		@$mol_mem
		before() {
			const res = new Date(this.now())
			res.setDate(res.getDate() - 1)
			return res
		}
		@$mol_mem
		dashboard_title() {
			const type = this.type()
			if (type === 'month') return this.page_title(type)
			const s = (this.$.$exso_sheets_shifts as any as { shift: () => string[] }).shift()
			return [this.before(), this.now()].reduce(
				(title, d, i, arr) =>
					title.replaceAll(
						`{${i + 1}}`,
						`${this.$.$exso_format.day(d)} (${s[arr.length - i].toLowerCase()})`,
					),
				super.dashboard_title(),
			)
		}

		@$mol_mem_key
		override dashboard_shifts(type: 'month' | 'day' | 'auto') {
			if (type === 'auto') type = this.type() as any
			if (type === 'month') return this.filter(['shifts', type])
			const list = this.$.$exso_sheets_shifts.list()
			const now = this.now()
			const before = this.before()
			const l = list.filter(({ date, shift_num }) => {
				const b = new Date(date.native)
				if (shift_num === 1) return now.getTime() === b.getTime()
				if (shift_num === 2) return before.getTime() === b.getTime()
				return false
			})
			return l
		}
		override blowings(type: 'month' | 'day' | 'auto') {
			return this.filter(['blowings', type])
		}

		@$mol_mem_key
		filter<T extends 'blowings' | 'shifts'>([key, type]: [T, 'month' | 'day' | 'auto']): T extends 'blowings'
			? $exso_sheets_blowing[]
			: $exso_sheets_shift[] {
			const list = key === 'shifts' ? this.$.$exso_sheets_shifts.list() : this.$.$exso_sheets_blowings.list()
			if (type === 'auto') type = this.type() as any
			const moment = this.date_moment()
			if (type === 'month') return list.filter(({ date }) => date.month === moment.month && date.year === moment.year) as any
			return list.filter(({ date }) => {
				const a = moment.native
				const b = date.native
				return (
					a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate()
				)
			}) as any
		}

		@$mol_mem_key
		site_shifts(id: string) {
			return this.shifts('auto').filter(s => s.place === id)
		}

		@$mol_action
		type_click(id: string) {
			this.type(id)
		}

		update() {
			this.$.$mol_dom_context.location.reload()
		}
		back_click() {
			this.$.$mol_dom_context.history.back()
		}

		api_path(path: string) {
			return this.$.$exso_sheets.api_path(path)
		}

		@$mol_mem
		user(next?: {} | null) {
			if (next !== undefined) return next
			const res = this.$.$mol_fetch.json(this.api_path('/auth/me'), { credentials: 'include' }) as {
				loggedIn?: boolean
			}
			if (res.loggedIn) return res
			return null
		}

		async login({ username, password }: { username: string; password: string }) {
			const res = await fetch(this.api_path('/auth/login'), {
				method: 'POST',
				body: JSON.stringify({ username, password }),
			})
			const json = await res.json()
			if (res.status !== 200) throw json
			this.user(json)
			return json
		}
		@$mol_mem
		slice_shifts() {
			const all = super.slice_shifts()
			if (this.type() === 'month') return all
			const middle = 14
			const slice = this.date_moment().day! < middle ? 1 : 2
			return all.filter(({ date }) => (slice === 1 ? date.day! <= middle : date.day! > middle))
		}
		@$mol_mem_key
		is_today(date: $mol_time_moment) {
			const today = new $mol_time_moment()
			return date.toString('YYYY-MM') === today.toString('YYYY-MM')
		}
		@$mol_mem
		plans() {
			if (this.type() !== 'month') return []
			const now = this.date_moment()
			const month = this.$.$exso_sheets_plans
				.list()
				.filter(({ date }) => now.month === date.month && now.year === date.year)
			return month
		}
	}
}
